import { trueFalseToYesNo, formatNumber } from '@/util/formatters'

//let ifPurchasedByOther = (obj) => { return obj.PurchasedByFreeText != undefined && obj.PurchasedByFreeText != null && obj.PurchasedByFreeText != '' }
let ifPurchasedByOther = (obj) => { return obj.purchasedByClaimant == false }

let gadgetDetailsInputs0 = [
    {
        id: 'deviceType',
        label: 'Type',
        type: 'text',
        placeholder: 'Type',
        dataPath: 'typeLabel'
    },
    {
        id: 'deviceMake',
        label: 'Make',
        type: 'text',
        placeholder: 'Make',
        dataPath: 'makeLabel'
    },
    {
        id: 'deviceModel',
        label: 'Model',
        type: 'text',
        placeholder: 'Model',
        dataPath: 'modelLabel'
    },
    {
        id: 'imei',
        label: 'IMEI',
        type: 'text',
        placeholder: 'IMEI',
        dataPath: 'imeiNo',
        copy: true
    },
    {
        id: 'serial',
        label: 'Serial',
        type: 'text',
        placeholder: 'Serial',
        dataPath: 'serialNo',
        copy: true
    },
    {
        id: 'description',
        label: 'Description / Details',
        type: 'textarea',
        placeholder: 'Description / Details',
        dataPath: 'description'
    },
    {
        id: 'purchasedType',
        label: 'Purchase Type',
        type: 'text',
        placeholder: 'Purchase Type',
        dataPath: 'purchaseTypeLabel'
    },
    {
        id: 'purchasedByClaimant',
        label: 'Purchased By Claimant',
        type: 'text',
        placeholder: 'Purchased By Claimant',
        dataPath: 'purchasedByClaimant',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'purchasedByFreeText',
        label: 'Purchased By',
        type: 'text',
        placeholder: 'Purchased By',
        dataPath: 'purchasedByFreeText',
        visible: ifPurchasedByOther
    },
    {
        id: 'purchasedByRelationshipLabel',
        label: 'Relationship',
        type: 'text',
        placeholder: 'Relationship',
        dataPath: 'relationshipTypeLabel',
        visible: ifPurchasedByOther
    },
    {
        id: 'purchaseDate',
        label: 'Purchase Date',
        type: 'text',
        placeholder: 'Purchase Date',
        dataPath: 'purchaseDate'
    },
    {
        id: 'purchasedFrom',
        label: 'Purchased From',
        type: 'text',
        placeholder: 'Purchased From',
        dataPath: 'purchaseLocation'
    },
    {
        id: 'provider',
        label: 'Network Provider',
        type: 'text',
        placeholder: 'Network Provider',
        dataPath: 'networkProviderLabel'
    },
    {
        id: 'contract',
        label: 'Contract Type',
        type: 'text',
        placeholder: 'Contract Type',
        dataPath: 'contractTypeLabel'
    },
    {
        id: 'damageTypes',
        label: 'Damage Types',
        type: 'text',
        placeholder: 'Damage Types',
        dataPath: 'damageTypes'
    },
    {
        id: 'damageDescription',
        label: 'Damage Description',
        type: 'textarea',
        placeholder: 'Damage Description',
        dataPath: 'damageDescription'
    },
    {
        id: 'policyholderPossession',
        label: 'Policyholder\'s possession',
        type: 'text',
        placeholder: 'Policyholder\'s possession',
        dataPath: 'policyholderPossession',
        customFormatter: trueFalseToYesNo
    }
]
let gadgetDetailsInputs1 = [
    {
        id: 'onRiskFor',
        label: 'On risk for (days)',
        type: 'text',
        placeholder: 'On risk for (days)',
        dataPath: 'onRiskForAtIncidentDate'
    },
    {
        id: 'coverStartDate',
        label: 'Cover start date',
        type: 'text',
        placeholder: 'Cover start date',
        dataPath: 'coverStartDate'
    },
    {
        id: 'coverLimit',
        label: 'Cover limit',
        type: 'text',
        placeholder: 'Cover limit',
        dataPath: 'value',
        customFormatter: formatNumber(2)
    },
    ...gadgetDetailsInputs0
]

let gadgetDetailsInputs2 = [
    {
        id: 'blacklisted',
        label: 'Blacklist Requested',
        type: 'text',
        placeholder: 'Blacklist Requested',
        dataPath: 'blacklistRequested',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'blacklistedDate',
        label: 'Date Blacklist Requested',
        type: 'text',
        placeholder: 'Date Blacklist Requested',
        dataPath: 'blacklistedRequestDate'
    },
    {
        id: 'reported',
        label: 'Theft / Loss Reported',
        type: 'text',
        placeholder: 'Theft / Loss Reported',
        dataPath: 'reportedToPolice',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'reportedDate',
        label: 'Theft / Loss Reported Date',
        type: 'text',
        placeholder: 'Theft / Loss Reported Date',
        dataPath: 'reportedToPoliceDate'
    },
    {
        id: 'policeStation',
        label: 'Police Station Details',
        type: 'text',
        placeholder: 'Police Station Details',
        dataPath: 'policeStationAddress'
    },
    {
        id: 'policeCrimeReference',
        label: 'Crime No / Reference',
        type: 'text',
        placeholder: 'Crime No / Reference',
        dataPath: 'policeCrimeReference'
    },
    {
        id: 'location',
        label: 'Device\'s Location',
        type: 'text',
        placeholder: 'Device\'s Location',
        dataPath: 'locationDuringIncident'
    }
]

let gadgetDetailsInputs3 = [
    {
        id: 'possessionTitle',
        label: 'Title',
        type: 'text',
        placeholder: 'Title',
        dataPath: 'possessionTitle'
    },
    {
        id: 'possessionFirstname',
        label: 'First name',
        type: 'text',
        placeholder: 'First name',
        dataPath: 'possessionFirstname'
    },
    {
        id: 'possessionLastname',
        label: 'Last name',
        type: 'text',
        placeholder: 'Last name',
        dataPath: 'possessionLastname'
    },
    {
        id: 'email',
        label: 'Email',
        type: 'text',
        placeholder: 'Email',
        dataPath: 'possessionEmail'
    },
    {
        id: 'telephone',
        label: 'telephone',
        type: 'text',
        placeholder: 'Telephone',
        dataPath: 'possessionTelephoneNumber'
    },
    {
        id: 'relationship',
        label: 'Relationship',
        type: 'text',
        placeholder: 'Relationship',
        dataPath: 'possessionRelationshipLabel'
    },
    {
        id: 'line1',
        label: 'Address',
        type: 'text',
        placeholder: 'Line 1',
        dataPath: 'possessionAddressLine1'
    },
    {
        id: 'line2',
        label: '',
        type: 'text',
        placeholder: 'Line 2',
        dataPath: 'possessionAddressLine2'
    },
    {
        id: 'town',
        label: 'Town / City',
        type: 'text',
        placeholder: 'Town / City',
        dataPath: 'possessionAddressCity'
    },
    {
        id: 'county',
        label: 'County',
        type: 'text',
        placeholder: 'County',
        dataPath: 'possessionAddressCounty'
    },
    {
        id: 'postcode',
        label: 'Postcode',
        type: 'text',
        placeholder: 'Postcode',
        dataPath: 'possessionAddressPostcode'
    }
]

let gadgetDetailsInputs4 = [
    {
        id: 'layFlat',
        label: 'Gadget Lays Flat',
        type: 'text',
        placeholder: 'Gadget Lays Flat',
        dataPath: 'layFlat',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'switchOn',
        label: 'Gadget Switches On',
        type: 'text',
        placeholder: 'Gadget Switches On',
        dataPath: 'switchOn',
        customFormatter: trueFalseToYesNo
    }
]

let gadgetDetailsInputs5 = [
    {
        id: 'deviceType',
        label: 'Type',
        type: 'text',
        placeholder: 'Type',
        dataPath: 'typeLabel'
    },
    {
        id: 'deviceMake',
        label: 'Make',
        type: 'text',
        placeholder: 'Make',
        dataPath: 'makeLabel'
    },
    {
        id: 'deviceModel',
        label: 'Model',
        type: 'text',
        placeholder: 'Model',
        dataPath: 'modelLabel'
    },
    {
        id: 'deviceValue',
        label: 'Device value',
        type: 'text',
        placeholder: 'Device value',
        dataPath: 'value',
        customFormatter: formatNumber(2)
    },
    {
        id: 'imei',
        label: 'IMEI',
        type: 'text',
        placeholder: 'IMEI',
        dataPath: 'imeiNo',
        copy: true
    },
    {
        id: 'simInDevice',
        label: 'SIM',
        type: 'text',
        placeholder: 'SIM',
        dataPath: 'simInDevice',
        copy: false,
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'serial',
        label: 'Serial',
        type: 'text',
        placeholder: 'Serial',
        dataPath: 'serialNo',
        copy: true
    },
    {
        id: 'description',
        label: 'Description / Details',
        type: 'textarea',
        placeholder: 'Description / Details',
        dataPath: 'description'
    },
    {
        id: 'purchasedType',
        label: 'Purchase Type',
        type: 'text',
        placeholder: 'Purchase Type',
        dataPath: 'purchaseTypeLabel'
    },
    {
        id: 'purchasedInUK',
        label: 'Purchased in UK',
        type: 'text',
        placeholder: 'Purchased in UK',
        dataPath: 'purchasedInUK',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'purchasedByClaimant',
        label: 'Purchased By Claimant',
        type: 'text',
        placeholder: 'Purchased By Claimant',
        dataPath: 'purchasedByClaimant',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'purchasedByFreeText',
        label: 'Purchased By',
        type: 'text',
        placeholder: 'Purchased By',
        dataPath: 'purchasedByFreeText',
        visible: ifPurchasedByOther
    },
    {
        id: 'purchasedByRelationshipLabel',
        label: 'Relationship',
        type: 'text',
        placeholder: 'Relationship',
        dataPath: 'relationshipTypeLabel',
        visible: ifPurchasedByOther
    },
    {
        id: 'purchaseDate',
        label: 'Purchase Date',
        type: 'text',
        placeholder: 'Purchase Date',
        dataPath: 'purchaseDate'
    },
    {
        id: 'purchasedFrom',
        label: 'Purchased From',
        type: 'text',
        placeholder: 'Purchased From',
        dataPath: 'purchaseLocation'
    },
    {
        id: 'provider',
        label: 'Network Provider',
        type: 'text',
        placeholder: 'Network Provider',
        dataPath: 'networkProviderLabel'
    },
    {
        id: 'contract',
        label: 'Contract Type',
        type: 'text',
        placeholder: 'Contract Type',
        dataPath: 'contractTypeLabel'
    },
    {
        id: 'damageTypes',
        label: 'Damage Types',
        type: 'text',
        placeholder: 'Damage Types',
        dataPath: 'damageTypes'
    },
    {
        id: 'damageDescription',
        label: 'Damage Description',
        type: 'textarea',
        placeholder: 'Damage Description',
        dataPath: 'damageDescription'
    },
    {
        id: 'policyholderPossession',
        label: 'Policyholder\'s possession',
        type: 'text',
        placeholder: 'Policyholder\'s possession',
        dataPath: 'policyholderPossession',
        customFormatter: trueFalseToYesNo
    }
]
export { gadgetDetailsInputs0, gadgetDetailsInputs1, gadgetDetailsInputs2, gadgetDetailsInputs3, gadgetDetailsInputs4, gadgetDetailsInputs5 }
